<template>
  <aside class="sidebar">
    <!-- Logo -->
    <div class="sidebar-logo">
      <div class="logo-mark">
        <el-image style="width: 100%; height: 28px;" src="images/icon.png" alt="logo"></el-image>
      </div>
    </div>

    <!-- New Chat -->
    <div class="sidebar-top">
      <button class="new-chat-btn" @click="handleNewChat">
        <el-image src="images/message-circle-plus.png" alt="new chat" />
        <span>新对话</span>
      </button>
    </div>

    <!-- Model Selector -->
<!--    <div
        class="model-selector"
        v-click-outside="() => showModelMenu = false"
    >
      <div class="model-current" @click="showModelMenu = !showModelMenu">
        <el-icon><Cpu /></el-icon>
        <span>{{ currentModel.name }}</span>
        <el-icon class="chevron" :class="{ open: showModelMenu }"><ArrowDown /></el-icon>
      </div>
      <Transition name="dropdown">
        <div v-if="showModelMenu" class="model-dropdown">
          <div
              v-for="m in MODELS"
              :key="m.id"
              class="model-item"
              :class="{ active: m.id === selectedModel }"
              @click="selectModel(m.id, $event)"
          >
            <div class="model-item-name">
              {{ m.name }}
              <span v-if="m.badge" class="model-badge">{{ m.badge }}</span>
            </div>
            <div class="model-item-desc">{{ m.description }}</div>
          </div>
        </div>
      </Transition>
    </div>-->

    <!-- Search -->
<!--    <div class="sidebar-search">
      <el-input
          v-model="searchQuery"
          placeholder="搜索对话"
          clearable
          class="search-input"
      >
        <template #prefix>
          <el-icon><Search /></el-icon>
        </template>
      </el-input>
    </div>-->

    <!-- Conversation List -->
    <div class="conv-list-wrap">
      <el-scrollbar class="conv-scrollbar">
        <div class="conv-list">
          <!-- 加载中 -->
          <div v-if="isLoading" class="loading-container">
            <el-icon class="loading-icon"><Loading /></el-icon>
            <span class="loading-text">加载中...</span>
          </div>

          <!-- 对话列表 -->
          <template v-else-if="filteredGroups.length > 0">
            <div v-for="group in filteredGroups" :key="group.label" class="conv-group">
              <div class="group-label">{{ group.label }}</div>
              <div
                  v-for="conv in group.items"
                  :key="conv.id"
                  class="conv-item"
                  :class="{ active: conv.id === activeConversationId }"
                  @click="handleConversationClick(conv.id)"
                  @mouseenter="hoveredId = conv.id"
                  @mouseleave="hoveredId = null"
              >
                <el-icon class="conv-icon"><ChatDotRound /></el-icon>

                <input
                    v-if="editingId === conv.id"
                    v-model="editingTitle"
                    v-focus
                    class="rename-input"
                    @blur="finishRename(conv.id)"
                    @keyup.enter="finishRename(conv.id)"
                    @keyup.esc="editingId = null"
                    @click.stop
                />
                <span v-else class="conv-title">{{ conv.title }}</span>

                <div
                    v-if="(hoveredId === conv.id || conv.id === activeConversationId) && editingId !== conv.id"
                    class="conv-actions"
                    @click.stop
                >
                  <button class="conv-action-btn" title="重命名" @click="startRename(conv.id, conv.title, $event)">
                    <el-icon><Edit /></el-icon>
                  </button>
                  <button class="conv-action-btn danger" title="删除" @click="handleDelete(conv.id, $event)">
                    <el-icon><Delete /></el-icon>
                  </button>
                </div>
              </div>
            </div>
          </template>

          <!-- 空状态 -->
          <div v-else-if="!isLoading" class="conv-empty">
            <el-icon><ChatDotRound /></el-icon>
            <span>{{ searchQuery ? '未找到相关对话' : '暂无对话记录' }}</span>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
      <template v-if="isLoggedIn">
        <el-popover
            trigger="click"
            placement="top"
        >
          <template #default>
            <div class="popover-content">
              <div class="popover-item" @click="openKnowledgeBase">
                <el-icon><MessageBox /></el-icon>
                <span style="margin-left: 5px;">知识库管理</span>
              </div>
              <el-popover
                  placement="right"
                  :width="200"
                  trigger="hover"
              >
                <template #default>
                  <div class="qrcode-content">
                    <el-image src="images/微信小程序.jpg" alt="微芯安小程序二维码" class="qrcode-image" ></el-image>
                    <p class="qrcode-text">扫码使用小程序</p>
                  </div>
                </template>
                <template #reference>
                  <div class="popover-item">
                    <el-icon><Iphone /></el-icon>
                    <span style="margin-left: 5px;">微芯安小程序</span>
                  </div>
                </template>
              </el-popover>
              <div class="popover-item" @click="logout">
                <el-icon><SwitchButton /></el-icon>
                <span style="margin-left: 5px;">退出登录</span>
              </div>
            </div>
          </template>
          <template #reference>
            <div class="user-info">
              <div class="user-avatar">
                <el-avatar :size="34" style="background: linear-gradient(135deg, #667eea, #764ba2); flex-shrink: 0;">
                <span style="font-size: 16px; font-weight: 600; color: white;">
                  {{ user?.userName?.charAt(0).toUpperCase() || 'U' }}
                </span>
                </el-avatar>
                <div class="user-details">
                  <span class="username">{{ maskedMobile }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-popover>
      </template>
      <template v-else>
        <div class="user-avatar" @click="openLoginDialog">
          <el-avatar :size="34" style="background: linear-gradient(135deg, #667eea, #764ba2); flex-shrink: 0;">
            <el-icon><User /></el-icon>
          </el-avatar>
          <span class="username">我的账户</span>
        </div>
      </template>
<!--      <div class="footer-icons">
        <el-tooltip content="设置" placement="top">
          <button class="footer-icon-btn"><el-icon><Setting /></el-icon></button>
        </el-tooltip>
        <el-tooltip content="清空所有对话" placement="top">
          <button class="footer-icon-btn" @click="chatStore.clearAll()"><el-icon><Delete /></el-icon></button>
        </el-tooltip>
      </div>-->
    </div>
  </aside>
  <!--Login Dialog-->
  <DialogCom width="660" title="" ref="loginRef">
    <Login @onClose="cancleDialog"/>
  </DialogCom>
  <!--知识库管理 Dialog-->
  <DialogCom width="900" title="知识库管理" :showClose="false" ref="knowledgeBaseRef">
    <KnowledgeBase @onClose="cancelKnowledgeBaseDialog"/>
  </DialogCom>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, watchEffect} from 'vue'
import { storeToRefs } from 'pinia'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useChatStore } from '@/stores/chat'
import useUserStore from '@/stores/user'
import { logout as logoutApi } from "@/AIApi";
import { MODELS } from '@/types'
import DialogCom from "@/components/dialogCom.vue";
import Login from "@/components/login.vue";
import KnowledgeBase from "@/components/KnowledgeBase.vue";

const chatStore = useChatStore()
const userStore = useUserStore()
const { groupedConversations, activeConversationId, selectedModel, isLoading} = storeToRefs(chatStore)
const { isLoggedIn, user } = storeToRefs(userStore)

const searchQuery = ref('')
const hoveredId = ref<string | null>(null)
const editingId = ref<string | null>(null)
const editingTitle = ref('')
const showModelMenu = ref(false)

// 格式化手机号显示：前三位 + *** + 后四位
const maskedMobile = computed(() => {
  if (!user.value?.mobile) return '用户'
  const mobile = user.value.mobile
  if (mobile.length === 11) {
    return `${mobile.substring(0, 3)}****${mobile.substring(7)}`
  }
  return mobile
})

// Custom directives in <script setup> use the vXxx naming convention
const vFocus = { mounted: (el: HTMLElement) => el.focus() }

const vClickOutside = {
  mounted(el: HTMLElement & { _out?: (e: Event) => void }, binding: { value: () => void }) {
    el._out = (e: Event) => { if (!el.contains(e.target as Node)) binding.value() }
    document.addEventListener('mousedown', el._out)
  },
  unmounted(el: HTMLElement & { _out?: (e: Event) => void }) {
    if (el._out) document.removeEventListener('mousedown', el._out)
  },
}

const currentModel = computed(() => MODELS.find(m => m.id === selectedModel.value) ?? MODELS[0])

const filteredGroups = computed(() => {
  if (!searchQuery.value.trim()) return groupedConversations.value
  const q = searchQuery.value.toLowerCase()
  return groupedConversations.value
      .map(g => ({ ...g, items: g.items.filter(c => c.title.toLowerCase().includes(q)) }))
      .filter(g => g.items.length > 0)
})
let userId = ""
// 监听登录状态，登录后加载数据
watchEffect(() => {
  if (isLoggedIn.value) {
    userId = userStore.user.userId
    chatStore.loadConversations(userId)
    console.log('filteredGroups=====',filteredGroups);
  }
})

function handleNewChat() {
  searchQuery.value = ''
  chatStore.clearActiveConversation()
}
// 点击对话项，加载上下文
async function handleConversationClick(id: string) {
  chatStore.setActive(id)
  // 如果该对话还没有消息，则加载上下文
  const conv = chatStore.conversations.find(c => c.id === id)
  if (conv && conv.messages.length === 0) {
    await chatStore.loadConversationContext(id)
  }
}

async function handleDelete(id: string, e: MouseEvent) {
  e.stopPropagation()
  try {
    await ElMessageBox.confirm('删除后无法恢复，确定删除这个对话？', '删除对话', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning',
    })
    await chatStore.deleteConversationApi(id)
    ElMessage({ message: '对话已删除', type: 'success', duration: 1500 })
  } catch { /* cancelled */ }
}

function logout() {
  ElMessageBox.confirm("您是否确认退出登录?", "温馨提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  }).then(async () => {
    try {
      // 调用登出接口
     await logoutApi({ mobile: user.value?.mobile || '' });

      // 清空对话列表
      chatStore.clearAllConversations();

      // 重置用户状态
      userStore.$reset();
      userStore.setLoggedInState(false);

      // 刷新页面
      location.reload();

      ElMessage.success("退出登录成功！");
    } catch (error) {
      console.error("退出登录失败:", error);
      ElMessage.error("退出登录失败，请重试");
    }
  });
}

function startRename(id: string, title: string, e: MouseEvent) {
  e.stopPropagation()
  editingId.value = id
  editingTitle.value = title
}

function finishRename(id: string) {
  if (editingTitle.value.trim()) {
    chatStore.renameConversation(id, editingTitle.value.trim())
  }
  editingId.value = null
}

function selectModel(id: string, e: MouseEvent) {
  e.stopPropagation()
  selectedModel.value = id
  showModelMenu.value = false
}
// region  登录弹窗
const loginRef = ref<DialogComInstance | null>(null);
function openLoginDialog(){
  loginRef.value?.updateShow(true)
}
function cancleDialog() {
  loginRef.value?.updateShow(false)
}
// endregion

// region 知识库管理弹框
 const knowledgeBaseRef = ref<DialogComInstance | null>(null);
function openKnowledgeBase(){
  knowledgeBaseRef.value?.updateShow(true)
}
function cancelKnowledgeBaseDialog() {
  knowledgeBaseRef.value?.updateShow(false)
}
// endregion
</script>

<style scoped>
.sidebar {
  width: 256px;
  min-width: 256px;
  height: 100vh;
  background: linear-gradient( 0deg, #EAEFFC 0%, #F8F9FC 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 16px 14px;
}

.sidebar-top { padding: 0 12px 10px; }
.new-chat-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  background: rgba(57,124,253,0.1);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(57,124,253,0.3);
  color: #397CFD;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.new-chat-btn:hover {
  background: rgba(57,124,253,0.3);
  border: 1px solid rgba(57,124,253,0.3);
}

.model-selector {
  margin: 0 12px 10px;
  position: relative;
}
.model-current {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border-radius: 8px;
  color: #989898;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}
.model-current:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #989898;
}
.chevron { margin-left: auto; transition: transform 0.2s; }
.chevron.open { transform: rotate(180deg); }

.model-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #252529;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}
.model-item {
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s;
}
.model-item:hover { background: rgba(255, 255, 255, 0.07); }
.model-item.active { background: rgba(78, 110, 242, 0.15); }
.model-item-name {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  gap: 6px;
}
.model-item-desc {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 2px;
}
.model-badge {
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
}

.sidebar-search { padding: 0 12px 8px; }
.search-input :deep(.el-input__wrapper) {
  background: rgba(255, 255, 255, 0.07) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px;
  box-shadow: none !important;
}
.search-input :deep(.el-input__inner) {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
}
.search-input :deep(.el-input__inner::placeholder) { color: rgba(255, 255, 255, 0.3); }
.search-input :deep(.el-input__prefix) { color: rgba(255, 255, 255, 0.35); }

/* 加载状态 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: rgba(255, 255, 255, 0.4);
  gap: 12px;
}

.loading-icon {
  font-size: 24px;
  animation: spin 1s linear infinite;
}

.loading-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.conv-list-wrap {
  flex: 1;
  overflow: hidden;
  padding: 0 6px;
}
.conv-scrollbar { height: 100%; }
.conv-list { padding: 4px 0 8px; }

.conv-group { margin-bottom: 8px; }
.group-label {
  font-size: 11px;
  color: #989898;
  padding: 6px 10px 4px;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.conv-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  min-height: 38px;
  position: relative;
}
.conv-item:hover { background: rgba(57,124,253,0.1); }
.conv-item.active { background: rgba(57,124,253,0.1); }

.conv-icon {
  font-size: 14px;
  color: rgba(17, 22, 37, 0.4);
  flex-shrink: 0;
}
.conv-title {
  flex: 1;
  font-size: 13px;
  color: #111625;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.conv-item.active .conv-title { color: rgb(17, 22, 37); }

.rename-input {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(78, 110, 242, 0.5);
  border-radius: 4px;
  color: #111625;
  font-size: 13px;
  padding: 2px 6px;
  outline: none;
  min-width: 0;
}

.conv-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
}

/* 鼠标悬停时显示操作按钮 */
.conv-item:hover .conv-actions {
  opacity: 1;
  visibility: visible;
}

/* 当前选中的对话项始终显示操作按钮 */
.conv-item.active .conv-actions {
  opacity: 1;
  visibility: visible;
}

.conv-action-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: rgba(17, 22, 37, 0.5);
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s;
}
.conv-action-btn:hover {
  background: rgba(57, 124, 253, 0.15);
  color: #397CFD;
}
.conv-action-btn.danger:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}
.conv-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 0;
  color: rgba(255, 255, 255, 0.25);
  font-size: 13px;
}
.conv-empty .el-icon { font-size: 28px; }

.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}
.user-info { flex: 1; }
.user-avatar { display: flex; align-items: center; gap: 9px;cursor: pointer; }
.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.username { font-size: 13px; color: #111625; }
.popover-item{
  padding: 8px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.popover-item:hover {
  background: rgba(255, 255, 255, 0.1);
}
.qrcode-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qrcode-image {
  width: 180px;
  height: 180px;
  object-fit: contain;
  border-radius: 8px;
}

.qrcode-text {
  font-size: 13px;
  color: #666;
  margin: 0;
  text-align: center;
}

</style>
